export default __webpack_public_path__ + "static/media/Sajjad_Sadiq_Herder_Content.4e490fde.jpg";